import React from 'react'
import { FaStar } from 'react-icons/fa'

const reviews = [
  {
    name: "Ujjwal Ananda Maity",
    college: "Ismail Yusuf College",
    stars: 5,
    feedback: "Excellent guidance and support to the student's skill development sessions were best. I have learned the best interview-cracking skills here.",
  },
  {
    name: "Satyabrat Sahoo",
    college: "ITER, SOA university, CSE",
    stars: 4,
    feedback: "My cloud computing internship provided hands-on experience in hosting websites and API integration, enhancing my skills and project management abilities. Grateful for mentorship and well-prepared for the dynamic field. Thank you Internselite team for the great opportunity.",
  },
  {
    name: "Anisha Ashok Takalkar",
    college: "Late. T.D Pathare College, BSC (Computer Science)",
    stars: 5,
    feedback: "It's just feeling amazing with doing study online classes with Internselite and having the chance to gain and improve my knowledge. The class was very supportive and active at the time of meeting. Overall, good.",
  },
  {
    name: "Aditya Kumar",
    college: "Noida International University, (BCA)",
    stars: 4,
    feedback: "The experience was really good with Internselite. The mentors were very well experienced and explained each and every topic very well. They always cleared our doubts, asked questions, and gave one-on-one attention.",
  },
  {
    name: "Soumya Ranjan Patra",
    college: "ITER, SOA University, CSE",
    stars: 5,
    feedback: "I am immensely grateful for Internselite's project-based approach, allowing me to translate theoretical knowledge into tangible achievements. This experience not only deepened my understanding but also instilled a strong sense of accomplishment in applying skills to real-world projects.",
  },
  {
    name: "Pankaj Kumar Dubey",
    college: "IPS Academy, Indore",
    stars: 4,
    feedback: "Really brilliant course, thank you very much. Very informative. This is going to really help, and the checklist is going to be an absolute bonus. So, really impressive. Thank you very much, I have really enjoyed it.",
  },
];

function CC_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-1'>Testimonial</h2>
                <p className='fs-6'>
                  Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.
                </p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.college}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {[...Array(5)].map((_, starIndex) => (
                          <li key={starIndex}>
                            <FaStar color={starIndex < review.stars ? "gold" : undefined} />
                          </li>
                        ))}
                      </ul>
                      <p className=''>
                        <i className='fas fa-quote-left pe-2 Review_not_copy'></i>{review.feedback}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CC_Review_Program_Page
